import { inject } from '@angular/core';
import {
  HttpEvent,
  HttpRequest,
  HttpHandlerFn,
  HttpInterceptorFn,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggerService } from '../services/logger.service';
import { environment } from '../../../../environments/environment';

export const httpErrorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const logger: LoggerService = inject(LoggerService);
  return next(request).pipe(
    catchError((response: HttpEvent<any>): Observable<HttpEvent<any>> => {
      if (!environment.production) {
        // Do something with the error
        logger.logError('Request error ' + JSON.stringify(response));
      }
      throw response;
    })
  );
};
